import { BACK_BUTTON, GET_COUNTRY_DATA } from '@/utils/store/getterTypes'

export default {
  /**
   * The back button
   *
   * @param state
   * @returns object
   */
  [BACK_BUTTON] (state) {
    return state.backButton
  },
  [GET_COUNTRY_DATA] (state) {
    return state.countriesData[state.country]
  }
}
